var _defs, _path, _path2, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmployment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 15 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#b7b7b7;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M6.88,7.79H8.11V7.21H6.88Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M12,7.51c0-.61,0-1.21,0-1.81V5.56A1.11,1.11,0,0,0,11.81,5a.93.93,0,0,0-.61-.35h0a1.36,1.36,0,0,0-.29,0H9.48C9.33,3.51,9.1,3.31,8,3.31H7c-.94,0-1.24.15-1.4.9a3.08,3.08,0,0,0-.07.39H4a1,1,0,0,0-1,1V5.7c0,.6,0,1.2,0,1.81,0,1,0,2.08,0,3.12a1,1,0,0,0,1.08,1h6.84a1,1,0,0,0,1.08-1C12,9.59,12,8.55,12,7.51ZM8.76,4.58H6.24a.83.83,0,0,1,0-.31v0h0c0-.2.21-.29.5-.28.52,0,1,0,1.55,0s.54.19.49.55C8.77,4.53,8.76,4.55,8.76,4.58Zm2.6,6.05c0,.37-.25.41-.55.41H10v0H5.81v0H4.19c-.3,0-.55,0-.55-.42V9.09h7.72ZM8.12,8.46H3.64c0-.77,0-1.5,0-2.21V5.94a2.73,2.73,0,0,1,0-.31A.43.43,0,0,1,4,5.25h6.88a.45.45,0,0,1,.45.38v.62c0,.72,0,1.44,0,2.21Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 3.72,
    y: 11.01,
    width: 7.65,
    height: 0.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmployment);
export default __webpack_public_path__ + "static/media/employment.c0d251435ac811d890db686af4b2c88a.svg";
export { ForwardRef as ReactComponent };